import { defineStore } from 'pinia'

import type {
	IFetchApiExportProtector,
	IFetchApiExportProtectorTemplate,
	IFetchAPIProtectorCompanyList,
	IFetchApiProtectorList,
	IFetchApiProtectorTypeList
} from '~/portal/api/apiProtectors.ts'
import {
	fetchApiDeleteProtectorDB,
	fetchApiExportProtector,
	fetchApiExportProtectorTemplate,
	fetchAPIProtectorCompanyList,
	fetchApiProtectorList,
	fetchApiProtectorTypeList
} from '~/portal/api/apiProtectors.ts'
import type { IProtectorsStoreTypes } from '~/portal/stores'

import type { components } from '../../../../schema.ts'

export const useProtectorsStore = defineStore('protectors', {
	state: (): IProtectorsStoreTypes => ({
		protectorsList: [],
		protectorTypeList: [],
		protectorsCompanyList: [],
		totalCount: 0
	}),
	actions: {
		async fetchProtectorsList(payload: IFetchApiProtectorList) {
			const response = await fetchApiProtectorList({
				...payload,
				params: { ...payload.params }
			})
			if (!response) return
			if (Array.isArray(response)) {
				this.protectorsList = response
			} else if ('results' in response && 'count' in response) {
				this.protectorsList = response.results
			}
		},
		async fetchProtectorTypeList(payload: IFetchApiProtectorTypeList) {
			const response = await fetchApiProtectorTypeList({
				...payload,
				params: {
					type: 'protector'
				}
			})
			if (response) this.protectorTypeList = response
		},
		async fetchProtectorsCompanyList(payload: IFetchAPIProtectorCompanyList) {
			const response = await fetchAPIProtectorCompanyList(payload)
			if (!response) return
			if (Array.isArray(response)) {
				this.totalCount = response.length
				const pageNum = (
					payload.params as {
						page?: string | number
					}
				)?.page
					? +(
							payload.params as {
								page: string | number
							}
						)?.page
					: 1
				if (pageNum > 1) {
					this.protectorsCompanyList = [
						...this.protectorsCompanyList,
						...response
					]
				} else this.protectorsCompanyList = response
			} else if ('results' in response && 'count' in response) {
				this.totalCount = response.count as number
				const pageNum = (payload.params as any)?.page
					? +(payload.params as any).page
					: 1
				if (pageNum > 1) {
					this.protectorsCompanyList = [
						...this.protectorsCompanyList,
						...(response.results as components['schemas']['GetProtector'][])
					]
				} else {
					this.protectorsCompanyList =
						response.results as components['schemas']['GetProtector'][]
				}
			}
		},
		async exportProtector(payload: IFetchApiExportProtector) {
			return await fetchApiExportProtector(payload)
		},
		async exportProtectorTemplate(payload: IFetchApiExportProtectorTemplate) {
			return await fetchApiExportProtectorTemplate(payload)
		},
		async deleteDbProtector(payload: { token: string; id: number }) {
			return await fetchApiDeleteProtectorDB(payload)
		}
	}
})
